import { render, staticRenderFns } from "./skills-table.vue?vue&type=template&id=17e24574&"
import script from "./skills-table.vue?vue&type=script&lang=js&"
export * from "./skills-table.vue?vue&type=script&lang=js&"
import style0 from "./skills-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports